import PreloadState from "../../../vendor_core/core/src/states/PreloadState";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ControllerManager from "../../../vendor_core/core/src/utils/ControllerManager";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UpdateUICommand } from "../../../vendor_core/core/src/commands/GameCommands";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import ClockController from "../../../vendor_core/core/src/controllers/ClockController";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import App from "../../../vendor_core/core/src/App";
import * as currency_config from "../../../vendor_core/core/src/baseConfigs/currency-config.json";
import ErrorModel from "../../../vendor_core/core/src/model/ErrorModel";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import CommManager from "../../../vendor_core/core/src/controllers/CommManager";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import { ISavedSettings } from "../../../vendor_core/core/src/model/ISavedSettings";
import RealityCheckModel from "../../../vendor_core/core/src/model/RealityCheckModel";
import RequestRegister from "../../../vendor_core/core/src/server/requests/RequestRegister";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import { ISBRealityCheckData } from "../../../vendor_core/server/data/ISBRealityCheckData";
import VendorModel from "../../../vendor_core/server/model/VendorModel";
import RelaxPOSTMessageController from "../../../vendor_core/server/RelaxPOSTMessageController";
import BBReelGroup from '../view/BBReelGroup';
import BBModel from "../model/BBModel";
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBUtils from '../utils/utils';
import PointerEvents from '../../../vendor_core/core/src/const/PointerEvents';
import BBMultiplierController from '../controllers/BBMultiplierController';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';

const BACK_COGS_COUNT = 4;

export default class BBPreloadState extends PreloadState {
    public enter(): void {
        super.enter();
        RelaxPOSTMessageController.gameLoadStarted();
    }
    startGame() {
        const reelGroup = InstanceFactory.getClass(
            "ReelGroup",
            true
        ) as BBReelGroup;

        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .addSubView(reelGroup, "ReelGroup", "reels");

        reelGroup.create(
            ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene(),
            this.getReelsStartSymbols(),
        );

        ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();

        // // Make sure the reels mask will give enough space for the wild syms, which has bigger bounds
        // let mask = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").mask;
        // let bounds = mask.getLocalBounds();

        // // Centering the mask pivot (the default is 0,0)
        // mask.pivot.set(bounds.width / 2, bounds.height / 2);

        // // Place back the mask to its original location
        // mask.position.set(mask.position.x + bounds.width / 2, mask.position.y + bounds.height / 2);

        // // And scaling it from its center
        // const maskScaleFactor = 1.08;
        // mask.scale.set(mask.scale.x * maskScaleFactor, mask.scale.y * maskScaleFactor);
        BBAnimationsHelper.playStartGameSymbolAnimations(reelGroup);

        //** ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ **/
        // let effect = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene().anims
        // for (let i = 1; i < 6; i++) {
        //     effect.get("sym_wild_glow" + i)["used"] = false;
        // }
        // let bigWinAnims = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene().anims
        // // debugger
        // bigWinAnims.forEach(anim => {
        //     anim.stop()
        //     anim.visible = false;
        // });
        //PRE CACHE THE ANIMATIONS TO AVOID LAG IN THE BASE GAMEPLAY
        // reelGroup.wildEffect({x: 100, y: 100}, {y: 100})
        // reelGroup.mainThunderBolt({position: {x:0, y:0}, width: 0, height: 0})
        // reelGroup.thunderBolts({position: {x:0, y:0}, width: 0, height: 0})
        // reelGroup.DESymbolAnimation({position: {x:0, y:0}, width: 0, height: 0})
        // FREESPINS BACKGROUND
        // let FSbackgroundLayer = ViewManager.getLayer("Background").setScene("freespins")
        // let FSdarkSky = FSbackgroundLayer.sceneSprites.get("bgr_darksky")
        // let FSdarkClouds = FSbackgroundLayer.sceneSprites.get("clouds_dark")
        // FSdarkClouds.alpha = 0;
        // FSdarkSky.alpha = 0;
        // MAIN BACKGROUND
        this.setUpBackground();
        // let darkSky = backgroundLayer.sceneSprites.get("bgr_darksky")
        // let darkClouds = backgroundLayer.sceneSprites.get("clouds_dark")
        // darkClouds.alpha = 0;
        // darkSky.alpha = 0;
        // backgroundLayer.anims?.forEach(anim => {
        //     anim.gotoAndStop(0)
        //     anim.visible = true;
        // });

        // fill logo color
        this.setUpBanner();


        this.setUpWindAnimations();
        SpinModel.cascadeIndex = SpinModel.cascades.length
        UIController.create();
        UpdateUICommand();
        this.startMusicPlayback();

        BBMultiplierController.setUp();

        // ViewManager.moveLayerBehind("MultiplierContent", "Reels")
        // MAKE WILDS GO ABOVE ALL OTHER SYMBOLS
        // reelGroup.reels.forEach(reel => {
        //     reel.symbols.forEach(symbol => {
        //         if (symbol.id == 0) {
        //             let parentSym = symbol.parent
        //             parentSym.removeChild(symbol);
        //             parentSym.addChild(symbol)
        //         }
        //     })
        // })
        // BBAnimationsHelper.playTextPopupBanner(Locale.getString("idol_banner"), 2, 1);
        RelaxPOSTMessageController.reportGameReady();
        RelaxPOSTMessageController.reportSound();
        BBUtils.repositionLogo()

        this.exit();
    }
    /**
     * @returns symbols ids matrix
     * @description Generates a fake start reels symbols ids grid that has 3 wilds every time.
     */
    private getReelsStartSymbols = (): number[][] => {
        let reelStopSymbols = SpinModel.reelStopSymbols;
        let wilds = BBUtils.searchWilds(reelStopSymbols);
        let reelStartSymbols: string[] = wilds.map(wild => `${wild.x}${wild.y}`);

        if (wilds.length !== 3) {
            while (reelStartSymbols.length < 3) {
                reelStartSymbols.push(this.generateStartWildPosition(reelStartSymbols))
            }
            reelStartSymbols.forEach(element => {
                reelStopSymbols[element[0]][element[1]] = 0;
            });;
        }

        return reelStopSymbols
    }

    private setUpBanner = () => {
        let bannerLayer = ViewManager.getLayer("Banners").getCurrentScene();
        let EELogo = bannerLayer.sceneSprites.get("ee-white-logo-p");
        EELogo.tint = 0x3399ff;
    }

    private setUpBackground = () => {
        let backgroundLayer = ViewManager.getLayer("Background").getCurrentScene()
        // backgroundLayer.sceneSprites.forEach(sp => sp.visible = false);
        backgroundLayer.orientationChangeCallback = () => BBUtils.repositionLogo();
    }
    private generateStartWildPosition = (currentWilds: string[]): string => {
        let reel = BBUtils.randomIntFromInterval(0, 7);
        let cell = BBUtils.randomIntFromInterval(0, 7);
        let result;
        if (currentWilds.includes(`${reel}${cell}`)) {
            result = this.generateStartWildPosition(currentWilds);
        } else {
            result = `${reel}${cell}`;
        }

        return result
    }

    private setUpWindAnimations = () => {
        let windAnim = ViewManager.getLayer("WindAnimation").getCurrentScene()
        // windAnim.visible = false;
        windAnim.anims.forEach((wind, animName) => {

            if (animName.includes("wind_animation_horisontal")) {
                let animIndex = parseInt(animName.split("wind_animation_horisontal")[1]);
                if (animIndex > 8) {
                    wind.scale.x *= -1;
                    wind.x += wind.width;
                    // wind.y -= 40
                    // wind.visible = false
                } else {
                    // wind.visible = false
                }
            } else {
                let animIndex = parseInt(animName.split("wind_animation")[1]);
                if (animIndex > 8) {
                    wind.scale.y *= -1
                    wind.y += wind.height;
                }
                // wind.visible = false
            }

            wind.visible = false;
        });
    }


    public preloadComplete() {

        RelaxPOSTMessageController.gameLoadCompleted();

        this.sendGetConfigURL()
        // this.loginUser();
        this.initSoundLoading();

        // TODO destroy preloader from view manager
    }

    public showStart() {
        App.assets.onResourcesLoaded();
        const preloadLayer = ViewManager.getLayer(DefaultLayers.Preloader);
        const scene = preloadLayer.setScene("start");
        scene.orientationChangeCallback = () => {
            this.setUpFontSize(scene);
        }
        this.setUpFontSize(scene);

        scene.interactive = true;
        scene.buttons.get("play").on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            preloadLayer.clear();
            if (ErrorModel.hasError()) {
                this.exit();
            } else {
                this.setUpScenes();
                this.setUpClock();
                this.startGame();
            }
        });
        // let welcomeScene = new BBWelcomeScreenView(() => {
        //     ViewManager.getLayer(DefaultLayers.Preloader).clear();
        //     welcomeScene.hide();
        //     ViewManager.getLayer("MultiplierContent").setScene("multiplier")
        // });
    }

    private sendGetConfigURL() {
        CommManager.send(
            RequestRegister.get("getclientconfigURL"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onGetConfigURLReceived(data);
            },
            this,
            (err) => {

                // THIS CODE IS ONLY FOR DEV BUILDS !!! THIS CODE NEED US TO WORK GAME ON OUR SERVER (clients.atom.......)
                // ConsoleUtil.red("[GET CLIENT CONFIG URL]: FAIL TO GET CDNCONFIG.JSON FROM THE SERVER", err);
                this.onGetConfigURLReceived(null);

                // THIS ROW IS FOR RELEASE BUILD !!!!!!
                // this.onError(err);

            }
        );
    }

    private onGetConfigURLReceived(data) {
        ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).parseParams(data);
        this.sendGetClientConfig();
    }

    private sendGetClientConfig() {
        CommManager.send(
            RequestRegister.get("getclientconfig"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onClientConfigReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    private onClientConfigReceived(data) {
        ConfigManager.getConfig(ConfigurationTypes.GAME).parseClientConfig(data);
        RelaxPOSTMessageController.configure({
            clientconfigResponse: data
        })
        this.loginUser();
        // this.initSoundLoading();
    }

    private setUpClock() {
        ControllerManager.addController(
            "clockController",
            new ClockController()
        );
    }

    private setUpScenes() {
        ViewManager.playDefault();
        this.setUpAnticipationScene();
    }

    private setUpAnticipationScene() {
        ViewManager.getLayer(DefaultLayers.Anticipation).setScene("open").spineAnimations.forEach(anim => anim.hide())
    }

    private setUpFontSize = (scene: SceneView) => {
        let longestStringTextField = this.getLongestTextField(scene.sceneTextFields as Map<string, TextField>);
        let minFontSize = longestStringTextField.style.fontSize;
        (scene.sceneTextFields as Map<string, TextField>).forEach(tx => {
            tx.style.fontSize = minFontSize;
        })

    }

    private getLongestTextField = (textFields: Map<string, TextField>) => {
        let result: TextField = null;
        textFields.forEach(field => {
            if (result && result.text.length < field.text.length) {
                result = field;
            } else {
                if (result === null) {
                    result = field;
                }
            }
        })

        return result
    }

    private loginUser(): void {
        // GameModel.gameConfig.partnerid = parseInt(
        //     GameModel.urlParams?.partnerid || "1"
        // );
        if (
            !GameModel.urlParams.moneymode ||
            GameModel.urlParams.moneymode == "real"
        ) {
            // debugger
            // this.showStart()
            this.sendTokenRequest();
        } else {
            this.sendFunMoneyLogin();
        }
    }

    protected sendTokenRequest() {
        CommManager.send(
            RequestRegister.get("tokenRequest"),
            (data) => {
                // console.log("[AuthState] Token response", data);
                this.onTokenReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected sendFunMoneyLogin() {
        CommManager.send(
            RequestRegister.get("funLoginRequest"),
            (data) => {
                console.log("[AuthState] FUN money login", data);
                RelaxPOSTMessageController.configure({
                    loginResponse: data
                })
                this.onLoginReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected sendLoginRequest() {
        CommManager.send(
            RequestRegister.get("loginRequest"),
            (data) => {
                // console.log("[AuthState] Login response", data);
                RelaxPOSTMessageController.configure({
                    loginResponse: data
                })
                this.onLoginReceived(data);
            },
            this,
            (err) => {
                this.onError(err);
            }
        );
    }

    protected onError(error) {
        console.log("[RelaxAuth] Error", error);
        ErrorModel.update(error);
        this.exit();
    }

    protected onTokenReceived(data) {
        GameModel.update(data);
        this.sendLoginRequest();
    }

    protected onLoginReceived(data) {
        GameModel.update(data);
        VendorModel.update(data);
        BetModel.update(data);
        BetModel.setInitialParams();
        this.resolveCurrency(data);
        SpinModel.update(data);
        BBModel.update(data);
        SpinModel.generateReelsets(); // only going to be used until proper spinner is made because currently fake reels are needed for

        // TODO check data that comes when there are freespins active

        this.setSettings(data.savedSettings);

        // If reality check limits were passed - send them to the server
        if (GameModel.urlParams.rcinterval || GameModel.urlParams.rcelapsed) {
            GameModel.hasRealityCheck = true;
            this.forceRealityCheckLimits();
        }

        // Update the reality check data
        this.configureRealityCheck(data);

        if (ErrorModel.hasError()) {
            this.exit();
        } else {
            this.showStart();
        }
    }

    private configureRealityCheck(data) {
        let realityCheckData: ISBRealityCheckData = data?.stats?.realityCheck;

        if (realityCheckData) {
            // Only setup Reality Check if there are any limits
            if (
                realityCheckData.lossLimit ||
                realityCheckData.sessionLimitSeconds
            ) {
                RealityCheckModel.update(realityCheckData);
                GameModel.hasRealityCheck = true;
            }
        }
    }

    private forceRealityCheckLimits() {
        CommManager.send(
            RequestRegister.get("setRealityCheckLimits"),
            (data) => {
                // console.log("[AuthState] Set RC Limits response", data);
                if (data.status == "ok") {
                    // Also force them in-game - if all is ok on the server
                    RealityCheckModel.update(<ISBRealityCheckData>{
                        sessionLimitSeconds: GameModel.urlParams.rcinterval,
                        sessionMinutes: GameModel.urlParams.rcelapsed,
                    });
                }
            },
            this
        );
    }

    private setSettings(savedSettings: ISavedSettings) {
        if (savedSettings) {
            // If there are Sound settings saved
            if (savedSettings.sound) {
                SoundController.toggleEffects(savedSettings.sound.effects);
                SoundController.toggleMusic(savedSettings.sound.music);
            }

            // If there are Bet settings saved
            if (
                savedSettings.bet &&
                savedSettings.bet.currentBet != undefined
            ) {
                CommandManager.execute(
                    Commands.SET_BET,
                    savedSettings.bet.currentBet
                );
            }

            // If there are Autoplay settings saved
            if (savedSettings.autoplay) {
                AutoplayModel.setAutoSpin(savedSettings.autoplay.spins || 0);
                AutoplayModel.setWinLimit(savedSettings.autoplay.winLimit || 0);
                AutoplayModel.setLossLimit(
                    savedSettings.autoplay.lossLimit || 0
                );
            }
        }
    }

    protected resolveCurrency(data) {
        if (data.stats && data.stats.currency) {
            BetModel.currency = {
                ISO: data.stats.currency,
                symbol: currency_config[data.stats.currency].symbol,
                decimals: currency_config[data.stats.currency].decimals,
            };
        }
    }
}
